import classnames from 'classnames';

export const mapToGridItemClass = (classNames) =>
  classnames('role-member-management__grid-item', classNames);
